import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { useForm } from 'react-hook-form'
import { BorderContainer } from '../borderedContainer'

export interface CreateMandateIBANFormValues {
  iban: string
}

interface DirectDebitTabNewConnection {
  onCreateMandate: (data: CreateMandateIBANFormValues) => void
  isLoading?: boolean
}

export const CreateMandateIBAN = ({ onCreateMandate, isLoading }: DirectDebitTabNewConnection) => {
  const handleSubmit = (data: CreateMandateIBANFormValues) => {
    onCreateMandate(data)
  }

  const form = useForm<CreateMandateIBANFormValues>({
    defaultValues: {
      iban: '',
    },
  })

  return (
    <BorderContainer
      aria-label="iban"
      sx={{
        gap: 3,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
        }}
      >
        <Typography
          variant="body1"
          sx={{
            color: 'text.primary',
            fontWeight: 600,
          }}
        >
          Add IBAN account number
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
          }}
        >
          Set the customers IBAN account number for direct debit
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <TextField {...form.register('iban')} label="IBAN account number" />
        <Box>
          <Button disabled={isLoading} onClick={form.handleSubmit(handleSubmit)} variant="primary">
            Create IBAN account
          </Button>
        </Box>
      </Box>
    </BorderContainer>
  )
}
